import { Staff } from './Staff';

export class Mails {


    idMails: number;
    tto: string;
    bcc: string;
    cc: string;
    corp: string;
    dateAjout: Date;
    froma: string;
    mailAdd: string;
    numero: number;
    objet: string;
    read: boolean;
    stared: boolean;
    visible: boolean;
    pjointe: boolean;
    reply: string;
    type: string;
    pass: string;
    utilisateursMailsUserId: Staff;
}
